import React from "react";
import { makeStyles, Theme } from "@material-ui/core";
import { KSwitch } from "@kyburz/kdesign-system";
import { Role } from "../../interfaces/RoleInterface";

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    fontSize: 20,
    fontWeight: 500,
    color: theme.palette.common.black,
    width: "100%",
    paddingBottom: 16,
    borderBottom: "1px solid #e8e8e8",
  },
  paper: {
    padding: 32,
    boxShadow: "none",
    maxHeight: 750,
    overflow: "scroll",
  },
  switches: {
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: 32,
    flexWrap: "wrap",
  },
}));

interface Props {
  title: string;
  roles: Role[];
  handleChange: (role: Role) => void;
}

const RoleSection: React.FC<Props> = ({
  title,
  roles,
  handleChange,
}: Props) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.header}>{title}</div>
      <div className={classes.switches}>
        {roles.map((x) => (
          <KSwitch
            key={x.label}
            name={x.name}
            onChange={() => handleChange(x)}
            checked={x.value}
            label={x.label}
            helperText={x.helperText}
            style={{ minWidth: 240 }}
            disabled={x.disabled}
          />
        ))}
      </div>
    </>
  );
};

export default RoleSection;
